import React, { useEffect, useRef, useState } from 'react';
import './quest-map-point-picker.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const MAX_POINTS = 10;

const QuestMapPointPicker = ({
  formData,
  points,
  onPointAdded,
  onPointMoved,
  gameData
}) => {

  useEffect(() => {
    console.log(formData);
  },[formData]);
  const imgRef = useRef(null);
  const draggingRef = useRef(null);
  const [draggingId, setDraggingId] = useState(null);

  const handleClick = (e) => {
    if (points.length >= MAX_POINTS) return;
    const rect = imgRef.current.getBoundingClientRect();
    const xPct = (e.clientX - rect.left) / rect.width;
    const yPct = (e.clientY - rect.top) / rect.height;
    onPointAdded({ xPct, yPct });
  };

  const handlePinPointerDown = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    e.currentTarget.setPointerCapture(e.pointerId);
    draggingRef.current = { id };
    setDraggingId(id);
  };

  const handlePinPointerMove = (e, id) => {
    if (!draggingRef.current || draggingRef.current.id !== id) return;
    const rect = imgRef.current.getBoundingClientRect();
    const xPct = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
    const yPct = Math.min(1, Math.max(0, (e.clientY - rect.top) / rect.height));
    onPointMoved(id, { xPct, yPct });
  };

  const handlePinPointerUp = (e, id) => {
    if (!draggingRef.current || draggingRef.current.id !== id) return;
    draggingRef.current = null;
    setDraggingId(null);
    e.stopPropagation();
  };

  if (!formData.mapImageUrl) return null;

  return (
    <div className='quest-map-point-picker'>
      <div><b>Instructions:</b> Click on the map to add checkpoints.
      Then, below the map, click on each checkpoint to edit its details.</div>
      <div className="g-space-1"></div>
      <div className={`qmpp-counter${points.length >= MAX_POINTS ? ' qmpp-counter--full' : ''}`}>
        {points.length}/{MAX_POINTS} checkpoints
      </div>
      <div className="g-space-1"></div>
      <div className={`qmpp-image-wrapper${points.length >= MAX_POINTS ? ' qmpp-image-wrapper--locked' : ''}`} onClick={handleClick}>
        <img
          ref={imgRef}
          src={
            formData.mapImageUrl.includes('http')
              ? formData.mapImageUrl
              : `https://app.gamably.com${formData.mapImageUrl}`
          }
          alt='Map'
          className='qmpp-map-image'
          draggable={false}
        />

        {points.length > 1 && (
          <svg className='qmpp-svg-overlay' viewBox='0 0 100 100' preserveAspectRatio='none'>
            <defs>
              <filter id='line-shadow' x='-20%' y='-20%' width='140%' height='140%'>
                <feDropShadow dx='0' dy='2' stdDeviation='1.5' floodColor='rgba(0,0,0,0.4)' />
              </filter>
            </defs>
            {points.slice(1).map((pt, i) => (
              <line
                key={i}
                x1={points[i].xPct * 100}
                y1={points[i].yPct * 100}
                x2={pt.xPct * 100}
                y2={pt.yPct * 100}
                className='qmpp-line'
                filter='url(#line-shadow)'
              />
            ))}
          </svg>
        )}

        {points.map((pt, i) => (
          <div
            key={pt.id}
            className={`qmpp-pin${draggingId === pt.id ? ' qmpp-pin--dragging' : ''}`}
            style={{ left: `${pt.xPct * 100}%`, top: `${pt.yPct * 100}%` }}
            onPointerDown={(e) => handlePinPointerDown(e, pt.id)}
            onPointerMove={(e) => handlePinPointerMove(e, pt.id)}
            onPointerUp={(e) => handlePinPointerUp(e, pt.id)}
            onClick={(e) => e.stopPropagation()}
          >
            <span className='qmpp-pin-label'>{i + 1}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuestMapPointPicker;
